"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const b2a_1 = require("b2a");
class AuthorizationBasic {
    constructor(usernameOrHeader, password) {
        this[Symbol.toStringTag] = 'AuthorizationBasic';
        const buildingFromHeader = password === undefined;
        if (buildingFromHeader) {
            const info = AuthorizationBasic.parseHeader(usernameOrHeader);
            this._username = info.username;
            this._password = info.password;
        }
        else {
            this._username = usernameOrHeader;
            this._password = password;
        }
    }
    /**
     * @return {string}
     */
    get username() {
        return this._username;
    }
    /**
     * @return {string}
     */
    get password() {
        return this._password;
    }
    /**
     * @return {string}
     */
    get header() {
        const credentialsEncoded = b2a_1.btoa(`${this._username}:${this._password}`);
        return `Basic ${credentialsEncoded}`;
    }
    static parseHeader(header) {
        const headerSplit = header.split(' ');
        if (headerSplit.length !== 2) {
            throw new Error(`'${header}' is not a valid header.`);
        }
        const type = headerSplit[0];
        if (type !== 'Basic') {
            throw new Error(`'${type}' type is not supported.`);
        }
        const credentialsJoined = b2a_1.atob(headerSplit[1]);
        const colonIndex = credentialsJoined.indexOf(':');
        if (colonIndex < 0) {
            throw new Error(`Malformed username:password: '${credentialsJoined}'.`);
        }
        return {
            username: credentialsJoined.slice(0, colonIndex),
            password: credentialsJoined.slice(colonIndex + 1),
        };
    }
}
exports.AuthorizationBasic = AuthorizationBasic;
//# sourceMappingURL=authorization-basic.js.map